import React from 'react';
import { translate } from '../Services/translation';

const CheckoutAssemblyCheckbox = ({ withAssembly, setWithAssembly }) => (
  <div className="checkout__assembly">
    <label htmlFor="withAssembly" className="custom-checkbox">
      <input
        id="withAssembly"
        onChange={() => setWithAssembly(!withAssembly)}
        checked={withAssembly}
        type="checkbox"
      />
      <span className="custom-checkbox-label">
        {translate(`checkout.withassembly`)}
      </span>
    </label>
  </div>
);

export default CheckoutAssemblyCheckbox;
